/**
 * PURPOSE: Componer la estructura autenticada principal de Winscore en tema claro.
 * RESPONSIBILITIES: Administrar el menú lateral y distribuir Navbar, Sidebar y contenido sin exponer selector de tema.
 * COLLABORATORS: Navbar.jsx, Sidebar.jsx, Main.jsx e index.js.
 * ROUTE: winscore/src/pages/Layout.jsx
 */

import React, { useState } from "react";
import Navbar from "../components/global/Navbar/Navbar";
import Sidebar from "../components/global/Sidebar/Sidebar";

import Main from "../ui/Main";

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="font-quickSand">
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isSidebarOpen={isSidebarOpen} />

      <Main>{children}</Main>
    </div>
  );
};

export default Layout;
